import type { ValueOf } from './util/typeUtils';

export const SCHUFA_STATE = {
    FAIL: 'FAIL',
    NO_INFO: 'NO_INFO',
    OK: 'OK',
} as const;

export const SCHUFA_DECISION = {
    NO: 'NO',
    YES: 'YES',
} as const;

export const SCHUFA_CONSENT = {
    FALSE: 'false',
    TRUE: 'true',
} as const;

export const SCHUFA_STATUS = {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    IDENTIFIER_EXPIRED: 'IDENTIFIER_EXPIRED',
    INVALID_IDENTIFIER: 'INVALID_IDENTIFIER',
    INVALID_TOKEN: 'INVALID_TOKEN',
    NOT_STARTED: 'NOT_STARTED',
    NOT_STARTED_ZCALL: 'NOT_STARTED_ZCALL',
    PARSING_ERROR: 'PARSING_ERROR',
    STARTED: 'STARTED',
    TOKEN_VALIDITY_EXPIRED: 'TOKEN_VALIDITY_EXPIRED',
} as const;

export const SCHUFA_RATE_TYPES = {
    MONTHLY: 'MONTHLY',
    UNKNOWN: 'UNKNOWN',
    YEARLY: 'YEARLY',
} as const;

export const SCHUFA_QUEUE_STATUSES = {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING',
} as const;

export type SCHUFA_QUEUE_STATUS = (typeof SCHUFA_QUEUE_STATUSES)[keyof typeof SCHUFA_QUEUE_STATUSES];

export const SCHUFA_BATCH_TRIGGER_REASONS = {
    BATCH_SIZE_REACHED: 'batch_size_reached',
    MANUAL_REQUEST_BULLMQ: 'manual_request_bullmq',
    MANUAL_RETRY_MYSQL: 'manual_retry_mysql',
    TIMEOUT_EXCEEDED: 'timeout_exceeded',
} as const;

export type SCHUFA_BATCH_TRIGGER_REASON = ValueOf<typeof SCHUFA_BATCH_TRIGGER_REASONS>;

export const SCHUFA_CODES = {
    AH: 'AH',
    AI: 'AI',
    AS: 'AS',
    AU: 'AU',
    BP: 'BP',
    BU: 'BU',
    BX: 'BX',
    BY: 'BY',
    CA: 'CA',
    CC: 'CC',
    CR: 'CR',
    DC: 'DC',
    EV: 'EV',
    FS: 'FS',
    FU: 'FU',
    GA: 'GA',
    GI: 'GI',
    GP: 'GP',
    H2: 'H2',
    H3: 'H3',
    H5: 'H5',
    H6: 'H6',
    H7: 'H7',
    H9: 'H9',
    HA: 'HA',
    HB: 'HB',
    HF: 'HF',
    HN: 'HN',
    HP: 'HP',
    HY: 'HY',
    IA: 'IA',
    IE: 'IE',
    IS: 'IS',
    K1: 'K1',
    K2: 'K2',
    K3: 'K3',
    K4: 'K4',
    KG: 'KG',
    KH: 'KH',
    KM: 'KM',
    KP: 'KP',
    KR: 'KR',
    KW: 'KW',
    KX: 'KX',
    M1: 'M1',
    M2: 'M2',
    M3: 'M3',
    M4: 'M4',
    M5: 'M5',
    M6: 'M6',
    M7: 'M7',
    M8: 'M8',
    MA: 'MA',
    ML: 'ML',
    MX: 'MX',
    MY: 'MY',
    OA: 'OA',
    OC: 'OC',
    PV: 'PV',
    RA: 'RA',
    RB: 'RB',
    RI: 'RI',
    RK: 'RK',
    RV: 'RV',
    S1: 'S1',
    S2: 'S2',
    S3: 'S3',
    SD: 'SD',
    SE: 'SE',
    SG: 'SG',
    SO: 'SO',
    SU: 'SU',
    SV: 'SV',
    SW: 'SW',
    SZ: 'SZ',
    UF: 'UF',
    UI: 'UI',
    US: 'US',
    WS: 'WS',
    WV: 'WV',
} as const;
export type SCHUFA_CODE = ValueOf<typeof SCHUFA_CODES>;

// https://confluence.synatix.de/pages/viewpage.action?spaceKey=KRED&title=SchufaResults
export const SCHUFA_NEGATIVE_CODES = [
    SCHUFA_CODES.AH,
    SCHUFA_CODES.AI,
    SCHUFA_CODES.AS,
    SCHUFA_CODES.AU,
    SCHUFA_CODES.CA,
    SCHUFA_CODES.DC,
    SCHUFA_CODES.EV,
    SCHUFA_CODES.FS,
    SCHUFA_CODES.FU,
    SCHUFA_CODES.GA,
    SCHUFA_CODES.GP,
    SCHUFA_CODES.H2,
    SCHUFA_CODES.H3,
    SCHUFA_CODES.H5,
    SCHUFA_CODES.H6,
    SCHUFA_CODES.H7,
    SCHUFA_CODES.H9,
    SCHUFA_CODES.HA,
    SCHUFA_CODES.HB,
    SCHUFA_CODES.IA,
    SCHUFA_CODES.IE,
    SCHUFA_CODES.IS,
    SCHUFA_CODES.KM,
    SCHUFA_CODES.KP,
    SCHUFA_CODES.KW,
    SCHUFA_CODES.OA,
    SCHUFA_CODES.OC,
    SCHUFA_CODES.PV,
    SCHUFA_CODES.RA,
    SCHUFA_CODES.RB,
    SCHUFA_CODES.RI,
    SCHUFA_CODES.RV,
    SCHUFA_CODES.S1,
    SCHUFA_CODES.S2,
    SCHUFA_CODES.S3,
    SCHUFA_CODES.SD,
    SCHUFA_CODES.SE,
    SCHUFA_CODES.SG,
    SCHUFA_CODES.SO,
    SCHUFA_CODES.SU,
    SCHUFA_CODES.SV,
    SCHUFA_CODES.SW,
    SCHUFA_CODES.SZ,
    SCHUFA_CODES.UF,
    SCHUFA_CODES.UI,
    SCHUFA_CODES.US,
    SCHUFA_CODES.WS,
    SCHUFA_CODES.WV,
] as const;
export type SCHUFA_NEGATIVE_CODE = (typeof SCHUFA_NEGATIVE_CODES)[number];

export const SCHUFA_REAL_ESTATE_CODES = [
    SCHUFA_CODES.BU,
    SCHUFA_CODES.BX,
    SCHUFA_CODES.BY,
    SCHUFA_CODES.HF,
    SCHUFA_CODES.HN,
    SCHUFA_CODES.HP,
    SCHUFA_CODES.HY,
    SCHUFA_CODES.KH,
    SCHUFA_CODES.MY,
] as const;
export type SCHUFA_REAL_ESTATE_CODE = (typeof SCHUFA_REAL_ESTATE_CODES)[number];
export const SCHUFA_CREDIT_TYPES = {
    Dispositionskredit: 'Dispositionskredit',
    Geschäftskredit: 'Geschäftskredit',
    Immobiliendarlehen: 'Immobiliendarlehen',
    Kontokorrentkredit: 'Kontokorrentkredit',
    Kreditkarte: 'Kreditkarte',
    Leasing: 'Leasing',
    Ratenkredit: 'Ratenkredit',
} as const;
export type SCHUFA_CREDIT_TYPE = ValueOf<typeof SCHUFA_CREDIT_TYPES>;

// Merkmale that represent a real-estate liability in the Umschuldungsplaner: the "Grundbesitz" column of
// https://synatix.atlassian.net/wiki/spaces/KRED/pages/3441364/SchufaResults, minus KH. KH is
// "Anfrage Immobilienkreditkonditionen" — an inquiry, so it must not become a liability, even though it stays in
// SCHUFA_REAL_ESTATE_CODES as a signal for the schufa_contains_real_estate_loan applicant flag.
// SCHUFA_REAL_ESTATE_CODES is also still missing BP, M7 and M8; converging the two is out of scope for KC-6451.
export const SCHUFA_IMMOBILIENDARLEHEN_CODES = [
    SCHUFA_CODES.BP,
    SCHUFA_CODES.BU,
    SCHUFA_CODES.BX,
    SCHUFA_CODES.BY,
    SCHUFA_CODES.HF,
    SCHUFA_CODES.HN,
    SCHUFA_CODES.HP,
    SCHUFA_CODES.HY,
    SCHUFA_CODES.M7,
    SCHUFA_CODES.M8,
    SCHUFA_CODES.MY,
] as const;
export type SCHUFA_IMMOBILIENDARLEHEN_CODE = (typeof SCHUFA_IMMOBILIENDARLEHEN_CODES)[number];

// Keyed by string rather than SCHUFA_CODE: Consors sends Merkmale we have not enumerated, and the position's
// code is nullish, so the lookup has to tolerate arbitrary input.
// SCHUFA issues most business Merkmale as a pair — one code for Freiberufler, one for Kleingewerbetreibende /
// Selbstständige — which is why they come in twos below. Merkmale that are Anfragen (AC, AG, KH, …) or negative
// entries are deliberately absent; resolveCreditType resolves them to `null`, and the calling command logs a
// warning and falls back to Ratenkredit.
export const SCHUFA_CODE_TO_CREDIT_TYPE: Partial<Record<string, SCHUFA_CREDIT_TYPE>> = {
    [SCHUFA_CODES.CC]: SCHUFA_CREDIT_TYPES.Kreditkarte, // Kreditkarte
    [SCHUFA_CODES.CR]: SCHUFA_CREDIT_TYPES.Kreditkarte, // revolvierende Kreditkarte
    [SCHUFA_CODES.GI]: SCHUFA_CREDIT_TYPES.Dispositionskredit, // Girokonto
    [SCHUFA_CODES.K1]: SCHUFA_CREDIT_TYPES.Geschäftskredit, // Betriebsmittelkreditlinie (Freiberufler)
    [SCHUFA_CODES.K2]: SCHUFA_CREDIT_TYPES.Geschäftskredit, // Betriebsmittelkreditlinie (Selbstständige)
    [SCHUFA_CODES.K3]: SCHUFA_CREDIT_TYPES.Geschäftskredit, // Investitionskredit (Freiberufler)
    [SCHUFA_CODES.K4]: SCHUFA_CREDIT_TYPES.Geschäftskredit, // Investitionskredit (Selbstständige)
    [SCHUFA_CODES.KG]: SCHUFA_CREDIT_TYPES.Dispositionskredit, // Kredit auf Girokonto
    [SCHUFA_CODES.KR]: SCHUFA_CREDIT_TYPES.Ratenkredit, // Kredit
    [SCHUFA_CODES.KX]: SCHUFA_CREDIT_TYPES.Ratenkredit, // Kredit mit Endfälligkeit
    [SCHUFA_CODES.M1]: SCHUFA_CREDIT_TYPES.Geschäftskredit, // geschäftliches Girokonto (Freiberufler)
    [SCHUFA_CODES.M2]: SCHUFA_CREDIT_TYPES.Geschäftskredit, // geschäftliches Girokonto (Selbstständige)
    [SCHUFA_CODES.M3]: SCHUFA_CREDIT_TYPES.Leasing, // geschäftliches Leasing (Freiberufler)
    [SCHUFA_CODES.M4]: SCHUFA_CREDIT_TYPES.Leasing, // geschäftliches Leasing (Selbstständige)
    [SCHUFA_CODES.M5]: SCHUFA_CREDIT_TYPES.Kreditkarte, // geschäftliche Kreditkarte (Freiberufler)
    [SCHUFA_CODES.M6]: SCHUFA_CREDIT_TYPES.Kreditkarte, // geschäftliche Kreditkarte (Selbstständige)
    [SCHUFA_CODES.MA]: SCHUFA_CREDIT_TYPES.Ratenkredit, // Mitverpflichtung für einen Ratenkredit
    [SCHUFA_CODES.ML]: SCHUFA_CREDIT_TYPES.Leasing, // Mobilien-Leasing
    [SCHUFA_CODES.MX]: SCHUFA_CREDIT_TYPES.Ratenkredit, // Mitverpflichtung für einen Kredit mit Endfälligkeit
    [SCHUFA_CODES.RK]: SCHUFA_CREDIT_TYPES.Kontokorrentkredit, // Rahmenkredit
    ...Object.fromEntries(
        SCHUFA_IMMOBILIENDARLEHEN_CODES.map((code) => [code, SCHUFA_CREDIT_TYPES.Immobiliendarlehen]),
    ),
};

// Official SCHUFA-Merkmal descriptions from
// https://synatix.atlassian.net/wiki/spaces/KRED/pages/3441364/SchufaResults
// Consors truncates `creditType` at ~12 chars (and sometimes mismatches it to the code). The UI
// keeps that Consors text in the table cell and looks the official name up by Merkmal code for the tooltip.
export const SCHUFA_CODE_TO_MERKMAL: Partial<Record<string, string>> = {
    '2W': 'PLZ / Wohnort / Straße + Hausnummer des 2. Wohnsitzes',
    A1: 'Anfrage Betriebsmittelkreditlinie für Freiberufler',
    A2: 'Anfrage Betriebsmittelkreditlinie für Kleingewerbetreibende / Selbstständige',
    A3: 'Anfrage Investitionskredit bzw. Anfrage zu Mobilien-Leasing / Mietkauf für Freiberufler',
    A4: 'Anfrage Investitionskredit bzw. Anfrage zu Mobilien-Leasing / Mietkauf für Kleingewerbetreibende / Selbstständige',
    A7: 'Anfrage zur selbstschuldnerischen Bürgschaft für ein Unternehmen',
    AA: 'Abweichende Anschrift zwischen Abfrage und gespeichertem Satz',
    AB: 'Anfrage zur Bürgschaft bei Blankobauspardarlehen, nicht grundpfandrechtlich gesichertem Kredit oder Mobilien-Leasing / Mietkauf',
    AC: 'Anfrage zu Kreditkarte',
    AG: 'Anfrage zum Girokonto',
    AH: 'Anfrage des Handels wegen Lieferung und Leistung',
    AI: 'Anfrage Inkasso nach Verzug des Betroffenen und / oder nach Erteilung eines Inkassoauftrages bei unbestrittener Forderung',
    AK: 'Anfrage zum Blankobauspardarlehen oder nicht grundpfandrechtlich gesichertem Kredit',
    AL: 'Anfrage zum Mobilien-Leasing / Mietkauf',
    AN: 'PLZ / Wohnort / Straße + Hausnummer der Anschrift',
    AR: 'Anfrage zur Kreditkarte mit revolvierendem Kreditrahmen',
    AS: 'Anfrage mit schriftlicher Begründung des berechtigten Interesses in anderen Fällen',
    AU: 'Anfrage zu Vertragsverhältnissen, die gemeldet worden sind oder hätten gemeldet werden können, zur Kontrolle der eigenen Anfragen und Meldungen',
    AW: 'Anfrage zu grundpfandrechtlich gesichertem Kredit',
    B1: 'Anfrage zum geschäftlichen Girokonto (für Freiberufler)',
    B2: 'Anfrage zum geschäftlichen Girokonto (für Selbstständige und Kleingewerbetreibende)',
    B3: 'Anfrage zum Leasing für geschäftliche Zwecke (für Freiberufler)',
    B4: 'Anfrage zum Leasing für geschäftliche Zwecke (für Selbstständige und Kleingewerbetreibende)',
    B5: 'Anfrage zur Kreditkarte für geschäftliche Zwecke (für Freiberufler)',
    B6: 'Anfrage zur Kreditkarte für geschäftliche Zwecke (für Selbstständige und Kleingewerbetreibende)',
    B7: 'Anfrage zum grundpfandrechtlich gesicherten Investitionskredit für geschäftliche Zwecke (für Freiberufler)',
    B8: 'Anfrage zum grundpfandrechtlich gesicherten Investitionskredit für geschäftliche Zwecke (für Selbstständige und Kleingewerbetreibende)',
    BP: 'Bürgschaft für grundpfandrechtlich gesicherten Kredit',
    BS: 'Basiskonto',
    BU: 'Bürgschaft für Blankobauspardarlehen, nicht grundpfandrechtlich gesicherten Kredit oder Mobilien-Leasing / Mietkauf',
    BX: 'Bürgschaft für Blankobauspardarlehen oder nicht grundpfandrechtlich gesicherten Kredit mit Endfälligkeit',
    BY: 'Bürgschaft für grundpfandrechtlich gesicherten Kredit (ohne Betrag)',
    CA: 'Kreditkartenkonto in Abwicklung',
    CC: 'Kreditkarte bzw. Kreditkartenkonto',
    CE: 'Einziehung der Kreditkarte wegen missbräuchlicher Verwendung',
    CR: 'Kreditkarte mit revolvierendem Kreditrahmen',
    DC: 'Dauerkonto des Handels',
    EEV: 'Ergänzung der eidesstattlichen Versicherung',
    ER: 'Erledigung einer Gesamtforderung',
    EV: 'Gläubigerbefriedigung ausgeschlossen / nicht nachgewiesen / Eidesstattliche Versicherung',
    FP: 'Fruchtlose Pfändung',
    FS: 'Fehlercode erscheint',
    FU: 'Anfrage zu Vertragsverhältnissen mit Freiberuflern, die gemeldet worden sind oder hätten gemeldet werden können, zur Kontrolle der eigenen Anfragen und Meldungen',
    GA: 'Girokonto in Abwicklung',
    GAS: 'Aufhebung des Gesamtvollstreckungsverfahrens',
    GEM: 'Einstellung des Gesamtvollstreckungsverfahrens',
    GI: 'Girokonto',
    GK: 'Kündigung Girokonto',
    GO: 'Geburtsort',
    GP: 'Pfändungsschutzkonto',
    GU: 'Anfrage zu Vertragsverhältnissen mit Kleingewerbetreibenden / Selbstständigen, die gemeldet worden sind oder hätten gemeldet werden können, zur Kontrolle der eigenen Anfragen und Meldungen',
    GVA: 'Abweisung des Antrages auf Eröffnung der Gesamtvollstreckung mangels Masse',
    GVE: 'Eröffnung bzw. Anordnung der Gesamtvollstreckung',
    H2: 'Hinweis auf andere Person / Schreibweise',
    H3: 'allgemeine Hinweise',
    H5: 'Selbstdarstellung des Betroffenen',
    H6: 'Hinweis auf Anschriftenermittlungsauftrag',
    H7: 'Hinweis auf unterschiedliche Personen',
    H9: 'Hinweis auf weitere Anschriften / Personen',
    HA: 'Hinweis auf Auslandsinformationen',
    HB: 'Nichtabgabe der Vermögensauskunft oder Haftbefehl',
    HF: 'Forward-Darlehen',
    HN: 'mit Verpflichtungserklärung gesichertes Bauspardarlehen für Kreditnehmer',
    HP: 'grundpfandrechtlich gesicherter Kredit',
    HV: 'Vollstreckung des Haftbefehls zur Erzwingung der eidesstattlichen Versicherung',
    HY: 'grundpfandrechtlich gesicherter Kredit (ohne Betrag)',
    IA: 'Antrag auf Eröffnung eines (vereinfachten) Insolvenzverfahrens mangels Masse abgewiesen bzw. Einstellung eines (vereinfachten) Insolvenzverfahrens mangels Masse',
    IBA: 'Abweisung bzw. Einstellung des Insolvenzverfahrens mangels Masse',
    IBE: 'Eröffnung des Insolvenzverfahrens / Beschluss',
    IE: '(vereinfachtes) Insolvenzverfahren eröffnet',
    IRB: 'Erteilung der Restschuldbefreiung',
    IRV: 'Versagung der Restschuldbefreiung',
    IS: 'Insolvenzverfahren aufgehoben',
    ISP: 'Schuldenbereinigungsplanverfahren eingeleitet / Antrag auf Eröffnung des Insolvenzverfahrens',
    IVA: 'Aufhebung von vorläufigen Sicherungsmaßnahmen im Insolvenzverfahren',
    IVE: 'außergerichtlicher Einigungsversuch im Rahmen des Insolvenzverfahrens',
    IVS: 'Anordnung von vorläufigen Sicherungsmaßnahmen im Insolvenzverfahren',
    IWP: 'Aufhebung des Insolvenzverfahrens',
    K1: 'Betriebsmittelkreditlinie für Freiberufler',
    K2: 'Betriebsmittelkreditlinie für Kleingewerbetreibende / Selbstständige',
    K3: 'Investitionskredit bzw. Mobilien-Leasing / Mietkauffinanzierung für Freiberufler',
    K4: 'Investitionskredit bzw. Mobilien-Leasing / Mietkauffinanzierung für Kleingewerbetreibende / Selbstständige',
    K7: 'Selbstschuldnerische Bürgschaft für ein Unternehmen',
    KAS: 'Aufhebung des Konkursverfahrens (nach Schlusstermin)',
    KB: 'Anfrage Basiskonto',
    KEM: 'Einstellung des Konkursverfahrens mangels Masse',
    KER: 'Eröffnung des Konkursverfahrens',
    KG: 'Nichtratenkredite und Kredite auf Girokonten',
    KH: 'Anfrage Immobilienkreditkonditionen',
    KK: 'Anfrage Kreditkonditionen',
    KL: 'Anfrage Leasingkonditionen',
    KM: 'Missbrauch eines Kontos oder einer Karte durch den rechtmäßigen Kontoinhaber',
    KON: 'Abweisung des Antrags auf Eröffnung des Konkurses mangels Masse',
    KP: 'Anfrage Pfändungsschutzkonto',
    KR: 'Blankobauspardarlehen oder nicht grundpfandrechtlich gesicherter Ratenkredit',
    KU: 'Kündigung von Konsumentenkrediten wegen Zahlungsverzugs mit mindestens zwei Raten',
    KW: 'Konto in Abwicklung',
    KX: 'Blankobauspardarlehen oder nicht grundpfandrechtlich gesicherter Kredit mit Endfälligkeit',
    LP: 'Lohnpfändung aufgrund eines Pfändungs- und Überweisungsbeschlusses',
    LZ: 'Lohnpfändung aufgrund Lohnabtretung',
    M1: 'geschäftliches Girokonto für Freiberufler',
    M2: 'geschäftliches Girokonto für Selbstständige und Kleingewerbetreibende',
    M3: 'Leasing für geschäftliche Zwecke (für Freiberufler)',
    M4: 'Leasing für geschäftliche Zwecke (für Selbstständige und Kleingewerbetreibende)',
    M5: 'Kreditkarte für geschäftliche Zwecke (für Freiberufler)',
    M6: 'Kreditkarte für geschäftliche Zwecke (für Selbstständige und Kleingewerbetreibende)',
    M7: 'Grundpfandrechtlich gesicherter Investitionskredit für geschäftliche Zwecke (für Freiberufler)',
    M8: 'Grundpfandrechtlich gesicherter Investitionskredit für geschäftliche Zwecke (für Selbstständige und Kleingewerbetreibende)',
    MA: 'Mitverpflichtung für ein Blankobauspardarlehen oder einen nicht grundpfandrechtlich gesicherten Ratenkredit',
    MB: 'Mahnbescheide',
    ML: 'Mobilien-Leasing / Mietkauf',
    MW: 'Möglicher neuer Wohnsitz',
    MX: 'Mitverpflichtung für ein Blankobauspardarlehen oder einen nicht grundpfandrechtlich gesicherten Kredit mit Endfälligkeit',
    MY: 'Mitverpflichtung für einen grundpfandrechtlich gesicherten Kredit (einschließlich der Bauspardarlehen mit Verpflichtungserklärung)',
    NA: 'Neue Anschrift',
    OA: 'Adressanfrage und/oder Lieferung von Amtsgerichtsdaten',
    OC: 'Permanente Anschriftenaktualisierung und/oder Lieferung von Amtsgerichtsdaten',
    OI: 'Lieferung von Insolvenzdaten zu Passivkunden',
    OS: 'Lieferung von Amtsgerichts- bzw. Insolvenzdaten zu Aktivkunden',
    PR: 'Wechselprotest',
    PV: 'Person verstorben',
    RA: 'Restschuldbefreiung angekündigt',
    RB: 'Restschuldbefreiung erteilt',
    RI: 'Rückgabe einer Forderung vom Inkassounternehmen / von einer internen Inkassostelle an den Gläubiger',
    RK: 'Rahmenkreditvertrag mit einem Kreditinstitut',
    RS: 'Scheckrückgabe mangels Deckung',
    RU: 'Rückstand nach Zwangsmaßnahmen',
    RV: 'Restschuldbefreiung versagt',
    S1: 'Schuldner ist seiner Pflicht zur Abgabe der Vermögensauskunft nicht nachgekommen',
    S2: 'Gläubigerbefriedigung nach dem Inhalt des Vermögensverzeichnisses ausgeschlossen',
    S3: 'Gläubigerbefriedigung nicht innerhalb eines Monats nach Abgabe der Vermögensauskunft nachgewiesen',
    SC: 'Scorewert, Risikoquote, Scorebereich',
    SD: 'Saldo aus fälliger/rückständiger oder titulierter Forderung',
    SE: 'Saldo nach gerichtlicher Entscheidung/Titulierung',
    SG: 'Saldo nach Gesamtfälligstellung',
    SM: 'Scheckkartenmissbrauch durch den Karteninhaber',
    SO: 'Konto (Platzhalter für positives Untermerkmal)',
    ST: 'ergänzt SCHUFA-Score bzw. Filtertext',
    SU: 'Auftrag zur Anschriftenermittlung (mit Schuldsaldo) über einen Schuldner, der unter Hinterlassung von Verbindlichkeiten mit unbekannter Anschrift verzogen ist - Suchauftrag wegen Hinterlassung von Schulden',
    SV: 'Saldovergleich zur fälligen/rückständigen oder titulierten Forderung',
    SW: 'Widerspruch zum titulierten Saldo',
    SZ: 'Saldo durch Forderungszession verkauft',
    UF: 'Uneinbringliche titulierte Forderung',
    UI: 'Übergabe einer Forderung an ein Inkassounternehmen / eine interne Inkassostelle zur Beitreibung',
    US: 'Uneinbringlicher Saldo ohne Titel nach SG',
    VA: 'PLZ / Wohnort / Straße + Hausnummer der Voranschrift',
    VAS: 'Aufhebung des Vergleichsverfahrens',
    VB: 'Vollstreckungsbescheid',
    VEM: 'Einstellung des Vergleichsverfahrens nach Rücknahme des Vergleichsvorschlages',
    VGA: 'Abweisung des Antrages auf Eröffnung des Vergleichsverfahrens',
    VGE: 'Eröffnung des Vergleichsverfahrens',
    WEV: 'wiederholte eidesstattliche Versicherung (§ 903 ZPO)',
    WS: 'Betroffener widerspricht beim Vertragspartner gegen den von diesem gemeldeten Saldo',
    WV: 'Betroffener widerspricht bei der SCHUFA gegen einen zu seiner Person gespeicherten Eintrag',
    XX: 'Platzhalter für nicht auskunftspflichtiges Merkmal',
    ZW: 'Zwangsvollstreckung',
};
